import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import Layout from '../components/layout';
import SEO from '../components/seo';

import { graphql } from 'gatsby';

Index.propTypes = {
	data: PropTypes.shape({
		heroImage: PropTypes.shape({
			childImageSharp: PropTypes.shape({
				fluid: PropTypes.object,
			}),
		}),
	}),
};

function trackStartTrackingClick() {
	// gtag is only on the page in production builds, and never when the visitor has Do Not Track on
	if (window.gtag) {
		window.gtag('event', 'start_tracking_click');
	}
}

export default function Index({ data }) {
	return (
		<Layout>
			<SEO />
			<section className="hero is-light">
				<div className="hero-body">
					<div className="container">
						<div className="columns is-vcentered">
							<div className="column">
								<h1 className="title">Know where you&apos;re at, all night</h1>
								<h2 className="subtitle">
									Log each drink as you go and see your running sobriety level.
									Use it before you decide what&apos;s next. No app install.
								</h2>
								<a
									href="https://app.drinktracker.app"
									className="button is-primary is-large"
									onClick={trackStartTrackingClick}
								>
									Start tracking for free →
								</a>
							</div>
							<div className="column">
								<div className="columns is-centered is-mobile">
									<div className="column is-two-thirds-mobile is-half-tablet">
										<figure>
											<Img
												fluid={data.heroImage.childImageSharp.fluid}
												loading="eager"
												fadeIn={false}
												alt="Drinktracker showing 1.28 drinks still in the system and a sober-by time of 10:17 PM."
											/>
											<figcaption>
												9pm, three drinks in, deciding on a fourth.
											</figcaption>
										</figure>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</Layout>
	);
}

export const query = graphql`
	query {
		heroImage: file(name: { eq: "hero" }) {
			childImageSharp {
				fluid(maxWidth: 470, quality: 100) {
					...GatsbyImageSharpFluid_withWebp
				}
			}
		}
	}
`;
